import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions, act } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mergeMap, withLatestFrom } from 'rxjs';
import { EventSelectors, PdvSelectors } from '../selectors';
import { EventActions } from '../actions';
import { EventModel } from 'src/app/models/event.model';
import { StateModel } from 'src/app/models/state.model';

@Injectable()
export class EventEffects {
  searchEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventActions.searchEvent),
      withLatestFrom(
        this.store.select(PdvSelectors.selectEvents),
        this.store.select(EventSelectors.selectFilteredState)
      ),
      mergeMap(([action, events, filteredState]) => {
        const filteredEvents = this.filterEvents(
          events,
          action.searchedEvent,
          filteredState
        );
        return [EventActions.setFilteredEvents({ filteredEvents })];
      })
    )
  );

  filterEventsByState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventActions.filterEventsByState),
      withLatestFrom(
        this.store.select(PdvSelectors.selectEvents),
        this.store.select(EventSelectors.selectSearchedEvent)
      ),
      mergeMap(([action, events, searchedEvent]) => {
        const filteredEvents = this.filterEvents(
          events,
          searchedEvent,
          action.filteredState
        );
        return [EventActions.setFilteredEvents({ filteredEvents })];
      })
    )
  );

  filterEventsByMonth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventActions.filterEventsByState),
      withLatestFrom(
        this.store.select(PdvSelectors.selectEvents),
        this.store.select(EventSelectors.selectSearchedEvent)
      ),
      mergeMap(([action, events, searchedEvent]) => {
        const filteredEvents = this.filterEvents(
          events,
          searchedEvent,
          action.filteredState
        );
        return [EventActions.setFilteredEvents({ filteredEvents })];
      })
    )
  );

  constructor(private actions$: Actions, private store: Store) {}

  filterEvents(
    events: EventModel[],
    searchedEvent: string,
    filteredState: StateModel | null
  ): EventModel[] | null {
    if (searchedEvent.length === 0 && filteredState === null) {
      return null;
    }

    return events.filter((event) => {
      const eventName = event.name.toLowerCase();
      const eventUF = event.uf.toLowerCase();
      const searchedName = searchedEvent.toLocaleLowerCase();
      const searchedUF = (filteredState?.uf ?? '').toLocaleLowerCase();
      return eventName.includes(searchedName) && eventUF.includes(searchedUF);
    });
  }

  filterEventsByMonth(
    events: EventModel[],
    searchedEvent: string,
    filteredState: StateModel | null
  ): EventModel[] | null {
    if (searchedEvent.length === 0 && filteredState === null) {
      return null;
    }
    return events.filter((event) => {
      const eventName = event.name.toLowerCase();
      const eventUF = event.uf.toLowerCase();
      const searchedName = searchedEvent.toLocaleLowerCase();
      const searchedUF = (filteredState?.uf ?? '').toLocaleLowerCase();
      return eventName.includes(searchedName) && eventUF.includes(searchedUF);
    });
  }
}